import React, { FC } from 'react';

import { useNavigateByName, useProfileData } from '../../../../hooks';
import { RouteDictionary } from '../../../../utils';
import { Money } from '../../../common';
import Username from '../../Username';

import './ProfileMenu.scoped.scss';

const ProfileMenu: FC = () => {
  const profileData = useProfileData();
  const navigate = useNavigateByName();
  return (
    <div
      className="profile-menu"
      role="button"
      tabIndex={0}
      title="Профиль"
      onClick={() => navigate(RouteDictionary.PROFILE)}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          navigate(RouteDictionary.PROFILE);
        }
      }}
    >
      <div className="profile-menu__user">
        <div className="profile-menu__info">
          <div className="profile-menu__name">
            <Username />
          </div>
          <div className="profile-menu__balance">
            <Money money={profileData.balance} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileMenu;
